module.exports = __webpack_public_path__ + "img/ct_meldm.760d8550.png";